<template>
    <nav class="menu-container">
     <h3> <!-- <font color="#00AB39">E3路</font>-->M313路<br>
      深圳M313路公交车路线</h3> 
     运行时间：<br>
     宝安机场场站 06:30-20:30 |<br>
     科技园公交总站 06:30-20:30<br>
参考票价：一票制2.5元<br>
公交公司：深圳巴士集团股份有限公司<br>

<br><br>

宝安机场场站—科技园公交总站<br>

<ol>
<li>安机场场站</li>
<li>华创达科技园南</li>
<li>固戍井湾新村</li>
<li>固戍海滨新村</li>
<li>固戍水质净化厂</li>
<li>碧海湾地铁站</li>
<li>西乡盐田大门</li>
<li>大益广场</li>
<li>丽景城</li>
<li>流塘地铁站</li>
<li>流塘公园南门</li>
<li>上川地铁站</li>
<li>诺铂广场</li>
<li>公园路西一巷</li>
<li>灵芝公园北</li>
<li>洪浪北地铁站</li>
<li>新安税务</li>
<li>中粮创芯公园北</li>
<li>雪花啤酒厂</li>
<li>留仙三路</li>
<li>汇聚创新园</li>
<li>南山福利中心</li>
<li>中兴公园</li>
<li>中兴人才公寓东</li>
<li>第二高级中学</li>
<li>直升机场</li>
<li>北环科苑天桥</li>
<li>科苑北(2)</li>
<li>深南科苑立交北(2)</li>
<li>高科技中心</li>
<li>中兴通讯(2)</li>
<li>科技园公交总站</li>  
</ol>

<br><br>
科技园公交总站—宝安机场场站<br>

<ol>
<li>科技园公交总站</li>
<li>中兴通讯(2)</li>
<li>高科技中心</li>
<li>深南科苑立交北(2)</li>
<li>科苑北(2)</li>
<li>科苑北环立交</li>
<li>海普瑞</li>
<li>直升机场</li>
<li>第二高级中学</li>
<li>中兴人才公寓东</li>
<li>深职院留仙洞校区</li>
<li>南山福利中心</li>
<li>汇聚创新园</li>
<li>留仙三路</li>
<li>雪花啤酒厂</li>
<li>中粮创芯公园北</li>
<li>新安税务</li>
<li>洪浪北地铁站</li>
<li>灵芝公园北</li>
<li>公园路西一巷</li>
<li>诺铂广场</li>
<li>文汇学校</li>
<li>上川地铁站</li>
<li>流塘公园南门</li>
<li>流塘地铁站</li>
<li>丽景城</li>
<li>宝安文具批发市场</li>
<li>大益广场</li>
<li>西乡盐田大门</li>
<li>碧海湾地铁站</li>
<li>固戍水质净化厂</li>
<li>固戍海滨新村</li>
<li>固戍井湾新村</li>
<li>华创达科技园南</li>
<li>宝安机场场站</li>  
</ol>




<RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
    </nav>
  </template>
  
  <script>
  import Icon from "@/components/Icon";
  export default {
    components: {
      Icon,
    },
    data() {
      return {
        items: [
          // 模板         {
          //  name: "azhan",
          //  title: "A站",
          //  icon: "chat",
          //  exact: true,
          //  },
  
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
        ],
      };
    },
  };
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(67, 47, 221);
      }
    }
  }
  //ol 列表数字改为圆圈  
  ol {
  counter-reset: section;
  list-style: none;
}

li {
  margin: 0 0 10px 0;
  line-height: 25px;
}

li:before {
  content: counter(section);
  counter-increment: section;
  display: inline-block;
  width: 25px;
  height: 25px;
  margin: 0 10px 0 0;
  border: 1px solid #228B22;  //绿色，同左边主导航一样颜色 #228B22
  border-radius: 100%;
  text-align: center;
}
  </style>
  
  
  
  
  
  